// UPDATE MAIN IMAGE WHEN THUMBNAIL IS CLICKED
document.addEventListener("DOMContentLoaded", () => {
  const productFeaturedContainer = document.querySelector(".featured__media");
  const productFeaturedSource = document.querySelectorAll("[data-featured-media] source");
  const thumbnailSelection = document.querySelector(".thumbnail");
  const thumbnail = document.querySelectorAll("[data-product-media-thumbnail]");
  const productPhotoImage = document.getElementById("ProductPhotoImg");
  let initialPhoto = "";

  // スワイプ用の状態管理
  let swipeState = {
    startX: 0,
    startY: 0,
    currentX: 0,
    currentY: 0,
    isDragging: false,
    threshold: 50, // スワイプ検出の最小距離（px）
    currentImageIndex: 0,
    visibleThumbnails: [] // 現在表示中のサムネイル配列
  };

  if (!thumbnailSelection || !productFeaturedContainer) return;
  // ---------------------------------------------

  // スワイプ機能: ヘルパー関数

  // 表示中のサムネイル配列を更新する関数
  function updateVisibleThumbnails() {
    requestAnimationFrame(() => {
      swipeState.visibleThumbnails = Array.from(thumbnail).filter((img) => {
        const computedStyle = window.getComputedStyle(img);
        return computedStyle.display !== 'none';
      });

      // 初期アクティブサムネイル設定（配列更新完了後）
      if (productPhotoImage && productPhotoImage.src) {
        swipeState.currentImageIndex = getCurrentImageIndex(productPhotoImage.src);
        updateActiveThumbnail(swipeState.currentImageIndex);
      }

      // スワイプナビゲーションボタンの表示を更新
      updateSwipeNavButtons();
    });
  }

  // 現在表示中の画像のインデックスを取得
  function getCurrentImageIndex(imageSrc) {
    // サムネイルのsrcから&width=を除去して比較
    const cleanSrc = imageSrc.replace(/&width=\d+/g, '');

    const index = swipeState.visibleThumbnails.findIndex((img) => {
      const thumbCleanSrc = img.src.replace(/&width=\d+/g, '');
      return cleanSrc.includes(thumbCleanSrc) || thumbCleanSrc.includes(cleanSrc);
    });

    return index >= 0 ? index : 0;
  }

  // サムネイルのアクティブクラスを更新
  function updateActiveThumbnail(index) {
    // 全てのサムネイルからアクティブクラスを削除
    thumbnail.forEach((img) => {
      img.classList.remove('thumbnail__item--active');
    });

    // 指定されたインデックスのサムネイルにアクティブクラスを追加
    if (swipeState.visibleThumbnails[index]) {
      swipeState.visibleThumbnails[index].classList.add('thumbnail__item--active');
    }
  }

  // スワイプナビゲーションボタンの表示/非表示を制御
  function updateSwipeNavButtons() {
    const navButtons = document.querySelector('[data-swipe-nav]');
    if (navButtons) {
      if (swipeState.visibleThumbnails.length > 1) {
        navButtons.classList.add('is-active');
      } else {
        navButtons.classList.remove('is-active');
      }
    }
  }

  // スワイプ機能: スワイプ処理関数

  // スワイプによる画像切り替え
  function switchImageBySwipe(direction) {
    const totalImages = swipeState.visibleThumbnails.length;

    if (totalImages === 0) return;

    // 方向に応じてインデックスを更新
    if (direction === 'left') {
      swipeState.currentImageIndex = (swipeState.currentImageIndex + 1) % totalImages;
    } else if (direction === 'right') {
      swipeState.currentImageIndex = (swipeState.currentImageIndex - 1 + totalImages) % totalImages;
    }

    // 対象のサムネイルを取得
    const targetThumbnail = swipeState.visibleThumbnails[swipeState.currentImageIndex];

    if (targetThumbnail) {
      // フェードアウト効果（既存コードを踏襲）
      if (initialPhoto !== targetThumbnail.src) {
        productFeaturedContainer.style.transition = "none";
        productFeaturedContainer.style.opacity = 0.5;
        initialPhoto = targetThumbnail.src;
        setTimeout(() => {
          productFeaturedContainer.style.transition = "opacity 0.3s ease-in";
          productFeaturedContainer.style.opacity = 1;
        }, 300);
      }

      // メイン画像のsource要素を更新
      productFeaturedSource.forEach((src) => {
        src.srcset = `${targetThumbnail.src.replace(
          '&width=100',
          '&width=' + src.width
        )} 1x,${targetThumbnail.src.replace(
          '&width=100',
          '&width=' + src.width * 2
        )} 2x `;
      });

      // アクティブサムネイルを更新
      updateActiveThumbnail(swipeState.currentImageIndex);
    }
  }

  // タッチ開始
  function handleTouchStart(e) {
    swipeState.startX = e.touches ? e.touches[0].clientX : e.clientX;
    swipeState.startY = e.touches ? e.touches[0].clientY : e.clientY;
    swipeState.isDragging = true;
  }

  // タッチ移動
  function handleTouchMove(e) {
    if (!swipeState.isDragging) return;

    swipeState.currentX = e.touches ? e.touches[0].clientX : e.clientX;
    swipeState.currentY = e.touches ? e.touches[0].clientY : e.clientY;
  }

  // タッチ終了
  function handleTouchEnd(e) {
    if (!swipeState.isDragging) return;

    const deltaX = swipeState.currentX - swipeState.startX;
    const deltaY = swipeState.currentY - swipeState.startY;

    // 水平方向の移動が垂直方向より大きい場合のみスワイプ判定
    if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > swipeState.threshold) {
      if (deltaX > 0) {
        // 右スワイプ（前の画像へ）
        switchImageBySwipe('right');
      } else {
        // 左スワイプ（次の画像へ）
        switchImageBySwipe('left');
      }
    }

    swipeState.isDragging = false;
    swipeState.startX = 0;
    swipeState.startY = 0;
    swipeState.currentX = 0;
    swipeState.currentY = 0;
  }

  thumbnailSelection.addEventListener("click", (e) => {
    if (e.target.dataset.productMediaThumbnail == "") {
      if (initialPhoto !== e.target.src) {
        productFeaturedContainer.style.transition = "none";
        productFeaturedContainer.style.opacity = 0.5;
        initialPhoto = e.target.src;
        setTimeout(() => {
          productFeaturedContainer.style.transition = "opacity 0.3s ease-in";
          productFeaturedContainer.style.opacity = 1;
        }, 300);
      }

      productFeaturedSource.forEach((src) => {
        src.srcset = `${e.target.src.replace(
          "&width=100",
          "&width=" + src.width
        )} 1x,${e.target.src.replace(
          "&width=100",
          "&width=" + src.width * 2
        )} 2x `;
      });

      // スワイプ状態の更新を追加
      swipeState.currentImageIndex = getCurrentImageIndex(e.target.src);
      updateActiveThumbnail(swipeState.currentImageIndex);
    }
  });

  // スワイプ機能: イベントリスナー

  // スワイプイベントリスナーを登録
  if (productFeaturedContainer) {
    // タッチイベント（モバイル）
    productFeaturedContainer.addEventListener('touchstart', handleTouchStart, { passive: true });
    productFeaturedContainer.addEventListener('touchmove', handleTouchMove, { passive: true });
    productFeaturedContainer.addEventListener('touchend', handleTouchEnd);

    // マウスイベント（デスクトップ）
    productFeaturedContainer.addEventListener('mousedown', handleTouchStart);
    productFeaturedContainer.addEventListener('mousemove', handleTouchMove);
    productFeaturedContainer.addEventListener('mouseup', handleTouchEnd);
    productFeaturedContainer.addEventListener('mouseleave', handleTouchEnd);
  }

  // スワイプナビゲーションボタンのクリックイベント
  const prevButton = document.querySelector('[data-swipe-prev]');
  const nextButton = document.querySelector('[data-swipe-next]');

  // ボタン連打防止用の状態管理
  let isButtonProcessing = false;

  if (prevButton) {
    prevButton.addEventListener('click', () => {
      if (isButtonProcessing) return;

      isButtonProcessing = true;
      switchImageBySwipe('right');

      // 一定時間後に連打防止フラグを解除
      setTimeout(() => {
        isButtonProcessing = false;
      }, 400);
    });
  }

  if (nextButton) {
    nextButton.addEventListener('click', () => {
      if (isButtonProcessing) return;

      isButtonProcessing = true;
      switchImageBySwipe('left');

      // 一定時間後に連打防止フラグを解除
      setTimeout(() => {
        isButtonProcessing = false;
      }, 400);
    });
  }

  // スワイプ機能: 初期化処理
  // 初期化: 表示中のサムネイル配列を構築（アクティブ設定とボタン表示も含む）
  updateVisibleThumbnails();

  // 商品スペックの配列形式の文字列を中点で結合する処理
  function formatArrayStrings() {
    const specElements = document.querySelectorAll('.specification p[data-specs], .specification p');
    
    specElements.forEach((element) => {
      const text = element.textContent.trim();
      
      // 配列形式の文字列を検出（例: ["小学生","中学生"] や ["屋内"]）
      const arrayMatch = text.match(/^\[(.*)\]$/);
      if (arrayMatch) {
        try {
          // JSON配列としてパースを試みる
          const parsed = JSON.parse(text);
          if (Array.isArray(parsed)) {
            // 中点（・）で結合
            element.textContent = parsed.join('・');
          }
        } catch (e) {
          // JSONパースに失敗した場合、カンマで分割して中点で結合を試みる
          const items = arrayMatch[1]
            .split(',')
            .map(item => item.trim().replace(/^["']|["']$/g, ''))
            .filter(item => item.length > 0);
          
          if (items.length > 0) {
            element.textContent = items.join('・');
          }
        }
      }
    });
  }

  // DOMContentLoaded後に実行
  formatArrayStrings();

  // MutationObserverで動的に追加される要素にも対応
  const observer = new MutationObserver(() => {
    formatArrayStrings();
  });

  const specificationContainer = document.querySelector('.product-specs');
  if (specificationContainer) {
    observer.observe(specificationContainer, {
      childList: true,
      subtree: true
    });
  }
});
